import styles from "./NotificationMenu.module.scss";
import React from "react";
import { Span, StyledLink } from "@netapp/bxp-design-system-react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import  { allMenus as i18nNamespace } from "../../../i18n/namespace";

const NotificationsFooter = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);

    return <div className={styles['sliding-menu-footer-notification']}>
        <Span level={14}>{t("for_more_info_go_to")} <StyledLink
            variant="text"
            to="/timeline"
            onClick={() => dispatch({ type: "MENU:CLOSE-WIDGET" })}>{t("timeline")}</StyledLink>
        </Span>
    </div>
}

export default NotificationsFooter;
